<template>
    <div id="itembank">
      <!-- begin breadcrumb -->
      <ol class="breadcrumb pull-right">
        <li><router-link :to="{path: '/'}">Home</router-link></li>
        <li>Bank Soal</li>
        <li class="active">{{ mapel }}</li>
      </ol>
      <!-- end breadcrumb -->
      <!-- begin page-header -->
      <h1 class="page-header">Bank Soal</h1>
      <!-- end page-header -->
      <div class="row">
        <div class="col-md-12">
          <!-- begin panel -->
          <div class="panel panel-inverse">
            <div class="panel-heading">
              <div class="btn-group pull-right">
                <span>Item yang dipilih: {{$store.state.tryout.selectedTO.length}}</span> &nbsp;&nbsp;
                <button type="button" style="max-width:200px; margin-right:1em" class="btn btn-success btn-xs" @click="submitExport()"><span class="fa fa-download"></span> Export to JSON</button>
                <button type="button" class="btn btn-success btn-xs" @click="$router.push({path: '/item-form', query: { mapel: $route.query.mapel }})"><span class="fa fa-plus"></span> Soal Baru</button>
              </div>
              <h4 class="panel-title">{{ mapel }}</h4>
            </div>
            <div class="panel-body">
              <form class="form-inline pull-right">
                <div class="form-group m-r-10">
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.itemCode !== ''">Kode => {{params.itemCode}} <b style="cursor:pointer;color:red;" @click="delByOneFilter('itemCode')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.label !== ''">Label => {{params.label}} <b  style="cursor:pointer;color:red;" @click="delByOneFilter('label')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px; padding:5px;" v-if="params.babName !== ''">Bab => {{params.babName}} <b style="cursor:pointer;color:red;" @click="delByOneFilter('babName')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.subbabName !== ''">Sub Bab => {{params.subbabName}} <b style="cursor:pointer;color:red;" @click="delByOneFilter('subbabName')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.subsubabName !== ''">Sub sub bab => {{params.subsubabName}} <b style="cursor:pointer; color:red;" @click="delByOneFilter('subsubabName')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.jenjang !== ''">Jenjang => {{params.jenjang}} <b style="cursor:pointer; color:red;" @click="delByOneFilter('jenjang')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.jenis !== ''">Jenis => {{params.jenis}} <b style="cursor:pointer; color:red;" @click="delByOneFilter('jenis')">X</b></span>
                  <span class="qry label label-info m-r-5" style="font-size:12px;padding:5px;" v-if="params.kelas !== ''">Kelas => {{params.kelas}} <b style="cursor:pointer; color:red;" @click="delByOneFilter('kelas')">X</b></span>
                </div>
                <div class="form-group m-r-10">
                  <input type="text" class="form-control" placeholder="Kata kunci" v-model="query">
                </div>
                <div class="form-group m-r-10">
                  <select class="form-control" v-model="field">
                    <!-- <option v-for="(value, key) in headers" :value="key" v-bind:key="key">{{ value }}</option> -->
                    <option value="code">Kode</option>
                    <option value="label">Label</option>
                    <option value="babName">Bab</option>
                    <option value="subbabName">Sub bab</option>
                    <option value="subsubabName">Sub sub bab</option>
                    <option value="jenjang">Jenjang</option>
                    <option value="jenis">Jenis</option>
                    <option value="kelas">Kelas</option>
                  </select>
                </div>
                <div class="form-group m-r-10">
                  <button type="button" class="btn btn-white" @click="doFilter()">Filter</button>
                </div>
                <div class="form-group m-r-10">
                  <button type="button" class="btn btn-white" @click="clearFilter()">Hapus Filter</button>
                </div>
                <!-- <div class="form-group m-r-10">
                  <select class="form-control">
                    <option value="desc">Baru ke Lama</option>
                    <option value="asc">Lama ke Baru</option>
                  </select>
                </div> -->
              </form>
              <app-datatable 
              :items="items" 
              :headers="headers" 
              :hasEdit="true" 
              :currentPageProp="this.params.page" 
              :hasAction="true" 
              :has-checkbox="true"
              v-on:selected="selectedItem = $event" 
              v-on:editNewTab="editSoalNewTab($event)" 
              v-on:dblClicked="editSoal()" 
              v-on:deleted="deleteSoal($event)">
              </app-datatable>
              <div v-if="$route.name === 'ItemBank'">
                <div class="btn-group pull-left">
                  <button class="btn btn-white" type="button">Total Page:</button>
                  <button class="btn btn-white" type="button">{{ this.maxPage }}</button>
                </div>
                <div class="btn-group pull-right" v-if="items.length > 0">
                  <button class="btn btn-white" type="button" v-on:click="goToPage(params.page-1)">
                    Previous
                  </button>
                  <input type="number" v-model="params.page" min="1" :max="maxPage" v-on:keyup.enter="goToPage(params.page)">
                  <button class="btn btn-white" type="button" v-on:click="goToPage(params.page+1)">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import ItemBankService from '@/services/itembank.js'
import ContentService from '@/services/content.js'
import DataTable from '@/components/plugins/DataTable'
import Moment from 'moment'

  export default {
    name: 'itembank',
    components: {
      'app-datatable': DataTable
    },
    data: function() {
      return {
        mapel: '',
        headers: ['Kode', 'Kelas', 'Bab', 'Sub Bab', 'Sub Sub Bab', 'Jenjang', 'Jenis', 'Eigen Score', 'Label','Status Dimunculkan', 'Created At'],
        items: [],
        selectedItem: null,
        maxPage: 0,
        currentPage: 1,
        query: '',
        field: '',
        params: {
          mapelId: this.$route.query.mapel,
          page: 1,
          itemCode: '',
          label: '',
          babName: '',
          subbabName: '',
          subsubabName: '',
          jenjang: '',
          jenis: '',
          kelas:''
        }
      }
    },
    watch: {
      '$route.query.mapel': function(mapelId) {
        var context = this
        this.mapel = this.getMapelNameById(mapelId)
        this.clearFilter()
      }
    },
    methods: {
      getMapelNameById: function(mapelId) {
        var mapels = JSON.parse(localStorage.getItem('mapels'))
        var found = mapels.find(function(element) {
          return element.id == mapelId
        })
        return found.nama
      },
      editSoal: function() {
        this.$router.push({path: '/item-form', query: {
          id: this.selectedItem.id,
          mapel: this.$route.query.mapel,
          edit: true}
        })
      },
      editSoalNewTab: function(value) {
        let routeData = this.$router.resolve({path: '/item-form', query: {
          id: value.id,
          mapel: this.$route.query.mapel,
          edit: true}
        })
        window.open(routeData.href, '_blank');
      },
      deleteSoal: function(data) {
        var context = this;
        var confirmed = window.confirm("Apakah anda yakin akan menghapus soal ini?")
        if (confirmed) {
          ItemBankService.deleteItem(data.id, function(result) {
            if (result.success) {
              var targetIndex = context.items.findIndex(function(item) {
                return item.id == data.id
              })

              context.items.splice(targetIndex, 1)
            }
          })
        }
      },
      doFilter() {  
        this.params.page = 1
        if(this.field === 'code') this.params.itemCode = this.query
        if(this.field === 'label') this.params.label = this.query
        if(this.field === 'babName') this.params.babName = this.query
        if(this.field === 'subbabName') this.params.subbabName = this.query
        if(this.field === 'subsubabName') this.params.subsubabName = this.query
        if(this.field === 'jenjang') this.params.jenjang = this.query
        if(this.field === 'jenis') this.params.jenis = this.query
        if(this.field === 'kelas') this.params.kelas = this.query
        this.loadData(this.$route.query.mapel)
        this.query = ''
      },
      delByOneFilter(keys) {
        this.params[keys] = ''
        this.loadData(this.$route.query.mapel)
      },
      clearFilter() {
        this.params = {
          mapelId: this.$route.query.mapel,
          page: 1,
          itemCode: '',
          label: '',
          babName: '',
          subbabName: '',
          subsubabName: '',
          jenjang: '',
          jenis: '',
          kelas:''
        }
        this.query = ''
        this.field = ''
        this.loadData(this.params.mapelId)
      },
      goToPage(p) {
        if(p > this.maxPage) {
          alert('Data hanya sampai '+ this.maxPage + ' Halaman')
        } else {
          this.params.page = p 
          this.loadData(this.$route.query.mapel)
        }
      },
      loadData: function(mapelId) {
        this.items = []
        var context = this
        ItemBankService.getItemsByMataPelajaran(this.params, function(result) {
          if(result.success) {
            result.data.forEach(function(item) {
              var subBab = !item.sub_bab ? '-' : item.sub_bab.nama
              var subSubBab = !item.sub_sub_bab ? '-' : item.sub_sub_bab.nama
              var createdAt = Moment(item.created_at).fromNow()
              var grades = []

              item.grades.forEach(function(grade) {
                grades.push(grade.grade)
              })
              var row = {
                id: item.id,
                data: [item.kode,
                  grades.length > 0 ? grades.sort().join(',') : '-',
                  item.bab.nama,
                  subBab,
                  subSubBab,
                  item.jenjang.nama,
                  item.jenis_soal.nama,
                  item.nilai_eigen,
                  item.label,
                  item.is_restricted ? '-' : '<i class="fa fa-check"></i>',
                  createdAt
                ]
              }
              context.maxPage = item.pages
              context.items.push(row)
            })
            
          }
        })
      },
      submitExport() {
        var context = this
        if(this.$store.state.tryout.selectedTO.length < 1) {
          alert('tidak ada item yang dipilih')
        } else {
          ContentService.exportItemBank({"ids":this.$store.state.tryout.selectedTO}, function (result) {
            alert('Data sukses diexport akan otomatis terdownload')
            context.$nextTick(function(){ context.$store.commit('tryoutSelected', []) })
          })
        }
      },
    },
    mounted: function() {
      if(this.$store.state.auth.loggedIn) {
        var context = this
        var mapelId = this.$route.query.mapel
        this.mapel = this.getMapelNameById(mapelId)
        this.loadData(mapelId)
      } else {
        this.$router.push('/login')
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// ItemBank.vue?5ba6a345